import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const ImageDiv = styled.div``;
export const paragraphDiv = styled.div``;
export const paragraphText = styled.p`
  font-family: DM Sans;
  font-size: 20px;
  font-weight: 700;
  text-align: left;
  margin-left: 10px;
`;
